import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getHelpRequestStatus = async () => {
  const { data } = await SigliveServiceSSE({ method: 'GET', url: '/productivity-host/help-request-status' });

  return data?.data;
};

export default getHelpRequestStatus;
